import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { SearchEntity } from 'v2/models';
import SearchProviderFilterView from '../../ActiveDataRequests/ProposalRespondModal/SearchProviderFilterView';

interface IInfoNoResponseYet {
  search: SearchEntity;
}

const InfoNoResponseYet = ({ search }: IInfoNoResponseYet) => {
  return (
    <>
      {search.questions.length && (
        <>
          <FormGroup>
            <label className="pt-4">
              Questions ({search.questions.length})
            </label>
          </FormGroup>
          {search.questions.map((item, index) => (
            <FormGroup key={index} className="mt-3">
              <label className="text-primary-dark">{item.name}</label>
            </FormGroup>
          ))}
        </>
      )}

      {search.filters.length && (
        <>
          <FormGroup>
            <label className="pt-4">
              Requirements ({search.filters.length})
            </label>
          </FormGroup>
          <SearchProviderFilterView filters={search.filters} />
        </>
      )}
    </>
  );
};

export default InfoNoResponseYet;
